import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { Venta } from "@/shared/types/venta";
import { sleep } from "@/shared/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";

export async function cancelVenta(id: string): Promise<Venta> {
    await sleep(1000);
    const response = await api.put("ventas/" + id + "/cancel");
    return response.data;
}

export function useCancelVentaMutation(id: string, mutationConfig: MutationConfig<Venta> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: async () => await cancelVenta(id),
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["ventas"] });
        },
    })
}

export interface CancelVentaMutationProps{
    id: string, 
    mutationConfig?: MutationConfig<Venta>,
    children?:(mutationResult:MutationResult<Venta>)=>ReactNode
}

export function CancelVentaMutation({
    id,
    children,
    mutationConfig
}:CancelVentaMutationProps){
    const mutationResult = useCancelVentaMutation(id, mutationConfig);
    return children&&children(mutationResult)
}